import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://tvsmfaapi.dev-url.com/';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

export const loginUser = createAsyncThunk(
  'login/loginUser',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('auth/login', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        if (action.payload.message === "Login successful") {
          toast.success('Login successful!');
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        toast.error(action.payload?.message || 'Login failed');
      });
  },
});

export const { logout } = loginSlice.actions;
export default loginSlice.reducer;